import styled from 'styled-components'

export const ImportModalContainer = styled.div`
  width: 720px;
  max-width: calc(100vw - 48px);
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  background: #ffffff;
`

export const ImportModalHeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 24px 32px 16px;
  flex-shrink: 0;
  border-bottom: 1px solid rgba(32, 32, 32, 0.08);
  pointer-events: ${(p) => (p.isImporting ? 'none' : '')};
  opacity: ${(p) => (p.isImporting ? '0.5' : '1')};
`

export const ImportModalHeaderHalfSide = styled.div`
  display: flex;
  flex-direction: ${(p) => (p.rightSide ? 'row' : 'column')};
  align-items: ${(p) => (p.rightSide ? 'flex-start' : 'stretch')};
  justify-content: ${(p) => (p.rightSide ? 'flex-end' : 'flex-start')};
  gap: 4px;
`

export const ImportModalTitle = styled.div`
  font-size: 20px;
  font-weight: 600;
  line-height: 28px;
  color: rgba(32, 32, 32, 1);
`

export const ImportModalSubtitle = styled.div`
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: rgba(32, 32, 32, 0.65);
`

export const ImportModalHeaderCloseIconWrapper = styled.div`
  height: 32px;
  width: 32px;
  display: grid;
  place-items: center;
  border-radius: 6px;
  cursor: pointer;
  flex-shrink: 0;
  margin-top: -4px;
  margin-right: -4px;

  :hover {
    background-color: rgba(32, 32, 32, 0.06);
  }
`

export const ImportModalContent = styled.div`
  padding: 24px 32px;
  overflow-y: auto;
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  gap: 24px;
`

export const ImportModalSection = styled.section`
  display: flex;
  flex-direction: column;
  gap: 12px;
`

export const ImportModalSectionHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

export const ImportModalSectionTitle = styled.h3`
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  color: rgba(32, 32, 32, 0.9);
`

export const ImportModalExcelGrid = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  gap: 16px;
  align-items: stretch;

  @media (max-width: 640px) {
    grid-template-columns: minmax(0, 1fr);
  }
`

export const ImportModalOptionsPanel = styled.div`
  border: 1px solid rgba(32, 32, 32, 0.1);
  border-radius: 8px;
  padding: 16px;
  background: rgba(32, 32, 32, 0.02);
  display: flex;
  flex-direction: column;
  gap: 14px;
`

export const ImportModalOptionsTitle = styled.div`
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  color: rgba(32, 32, 32, 0.55);
`

export const ImportModalBody = styled.div`
  border: 1px dashed rgba(32, 32, 32, 0.22);
  border-radius: 8px;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: ${(p) => (p.$compact ? '112px' : '168px')};
  height: 100%;
  padding: 20px 16px;
  background-color: #ffffff;
  transition: background-color 0.15s ease, border-color 0.15s ease;

  :hover {
    background-color: rgba(10, 161, 244, 0.03);
    border-color: rgba(10, 161, 244, 0.7);

    section {
      background-color: rgba(10, 161, 244, 1);

      svg path {
        fill: #ffffff;
      }
    }
  }
`

export const ImportModalDropContainer = styled.input`
  opacity: 0;
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  cursor: pointer;
  z-index: 5;
`

export const ImportModalDragFileBanner = styled.div`
  color: rgb(80, 18, 18);
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
`

export const ImportModalAddFileIconWrapper = styled.section`
  height: 40px;
  width: 40px;
  display: grid;
  place-items: center;
  border-radius: 50%;
  background-color: rgba(10, 161, 244, 0.1);
  flex-shrink: 0;
  pointer-events: none;

  svg {
    width: 18px;
    height: 18px;

    path {
      fill: rgba(10, 161, 244, 1);
      fill-opacity: 1;
    }
  }
`

export const ImportModalAddFileTitle = styled.div`
  font-weight: 500;
  font-size: 15px;
  line-height: 20px;
  pointer-events: none;
  text-align: center;
`

export const ImportModalAddFileSubTitle = styled.div`
  font-weight: 400;
  font-size: 13px;
  line-height: 16px;
  color: rgba(32, 32, 32, 0.65);
  pointer-events: none;
  text-align: center;
`

export const ImportModalFileWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  min-width: 0;
  padding: 14px 16px;
  border: 1px solid rgba(32, 32, 32, 0.1);
  border-radius: 8px;
  background: rgba(10, 161, 244, 0.04);
  min-height: ${(p) => (p.$compact ? '112px' : 'auto')};
  height: 100%;
`

export const ImportModalFileDetailsWrapper = styled.div`
  display: flex;
  align-items: center;
  min-width: 0;
  flex: 1;
`

export const ImportModalFileIconWrapper = styled.div`
  width: 36px;
  height: 36px;
  display: grid;
  place-items: center;
  border-radius: 50%;
  flex-shrink: 0;
  background-color: ${(p) => (p.error ? 'rgba(225, 25, 0, 0.1)' : 'rgba(10, 161, 244, 0.12)')};

  svg path {
    fill-opacity: 1;
    fill: ${(p) => (p.error ? 'rgba(225, 25, 0)' : 'rgba(10, 161, 244)')};
  }
`

export const ImportModalFileMeta = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  margin-left: 12px;
  min-width: 0;
  flex: 1;
  overflow: hidden;
`

export const ImportModalFileActionsWrapper = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
  flex-shrink: 0;
`

export const ImportModalFileValidationBanner = styled.div`
  height: 24px;
  color: #ffffff;
  font-size: 12px;
  line-height: 16px;
  font-weight: 400;
  border-radius: 4px;
  padding: 4px 8px;
  background-color: #e11900;
`

export const ImportModalFileName = styled.div`
  font-size: 14px;
  line-height: 18px;
  font-weight: 500;
  overflow-wrap: anywhere;
  word-break: break-word;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
`

export const ImportModalFileSize = styled.div`
  font-size: 13px;
  line-height: 16px;
  font-weight: 400;
  color: rgba(32, 32, 32, 0.65);
`

export const ImportModalFileDeleteIconWrapper = styled.div`
  height: 32px;
  width: 32px;
  display: grid;
  place-items: center;
  border-radius: 6px;
  cursor: pointer;

  :hover {
    background-color: rgba(225, 25, 0, 0.05);

    svg path {
      fill-opacity: 1;
      fill: rgba(225, 25, 0);
    }
  }
`

export const ImportModalFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 16px 32px 24px;
  border-top: 1px solid rgba(32, 32, 32, 0.08);
  flex-shrink: 0;
  background: #ffffff;
  pointer-events: ${(p) => (p.isImporting ? 'none' : '')};
  opacity: ${(p) => (p.isImporting ? '0.5' : '1')};
`

export const ImportModalFooterBtnWrapper = styled.div`
  display: flex;
  gap: 12px;
`

export const ImportModalTemplateWrapper = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  position: relative;
  user-select: none;
`

export const ImportModalTemplateTitle = styled.div`
  font-size: 14px;
  line-height: 24px;
  font-weight: 400;
  text-decoration: underline;
  color: rgba(10, 161, 244, 1);

  :hover {
    color: rgba(8, 129, 196, 1);
  }
`

export const ImportModalTemplateIconWrapper = styled.div`
  height: 32px;
  width: 32px;
  display: grid;
  place-items: center;
  border-radius: 50%;
  background-color: rgba(32, 32, 32, 0.05);

  svg path {
    fill-opacity: 1;
    fill: rgba(32, 32, 32);
  }
`

export const ImportModalStatusWrapper = styled.div`
  margin: 16px 32px 180px 32px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  color: ${(p) => (p.error ? '#E11900' : 'rgba(32, 32, 32, 0.7)')};
`

export const ImportModalStatusIcon = styled.div`
  height: 16px;
  width: 16px;
  display: grid;
  place-items: center;
  cursor: pointer;

  svg path {
    fill: rgba(10, 161, 244);
    fill-opacity: 1;
  }
`

export const ImportModalErrorBannerWrapper = styled.div`
  padding: 20px 24px;
  border: 1px solid rgba(225, 25, 0, 0.35);
  border-radius: 8px;
  background-color: rgba(225, 25, 0, 0.04);
`

export const ImportModalErrorBannerTitle = styled.div`
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  margin-bottom: 6px;
  color: #e11900;
`

export const ImportModalErrorBannerText = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  color: rgba(32, 32, 32, 0.75);
  margin-bottom: 16px;
`

export const ImportModalErrorBannerFooter = styled.div`
  display: flex;
  gap: 20px;
`

export const ImportModalErrorBannerFooterText = styled.div`
  font-weight: 400;
  line-height: 16px;
  font-size: 14px;
  cursor: pointer;
  text-decoration: underline;
  color: ${(p) => (p.showErrors ? 'rgba(10, 161, 244, 1)' : 'rgba(32, 32, 32, 1)')};
`

export const ImportModalImportBanner = styled.div`
  height: 265px;
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  padding-top: 80px;
`

export const ImportModalImportBannerTitle = styled.div`
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  margin-bottom: 8px;
`

export const ImportModalImportBannerText = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  color: rgba(32, 32, 32, 0.7);
`

export const ImportModalImportBannerIcon = styled.div`
  height: 48px;
  width: 48px;
  display: grid;
  place-items: center;
  border-radius: 50%;
  background-color: #0aa1f4;
  margin-bottom: 24px;
`

export const ImportModalTemplateIconDropWrapper = styled.div`
  height: 24px;
  width: 24px;
  display: grid;
  place-items: center;

  :hover {
    svg path {
      fill-opacity: 1;
    }
  }
`

export const ImportModalTemplatesDropDownMenuWrapper = styled.div`
  border-radius: 8px;
  padding: 8px 0;
  background: #ffffff;
  position: absolute;
  top: -190px;
  z-index: 5;
  box-shadow: 0 2px 8px -2px rgba(32, 32, 32, 0.1);
  border: 1px solid rgba(32, 32, 32, 0.1);
`

export const ImportModalTemplatesDropDownItemWrapper = styled.div`
  height: 40px;
  display: flex;
  gap: 8px;
  padding: 0 32px 0 16px;
  align-items: center;

  :hover {
    background: rgba(32, 32, 32, 0.05);
  }
`

export const ReassessmentCheckboxContainer = styled.div`
  display: flex;
  align-items: flex-start;

  label {
    align-items: flex-start;
  }
`
